module.exports = __webpack_public_path__ + "img/send_button.0837e7da.svg";